/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

/*
 * Use this directive to insert html markup, e.g. input field or link, inside a string. This helps the localization team
 * place the input or link wherever it makes most sense in different languages.
 *
 * How to use:
 * <anytag acc-tag-inside-string text="some text with %[input] in it">
 *   <input type="text" ...>
 * </anytag>
 *
 * <anytag acc-tag-inside-string text="some text with %[link_name] in it">
 *   <a href="text" ...>{{ 'link_name' | translate }}</a>
 * </anytag>
 *
 */

angular.module('access.Utils')
    .directive('accTagInsideString', ['$translate', '$rootScope', function ($translate, $rootScope) {
        return {
            scope: true,
            transclude: true,
            template: '<span ng-hide="loading">{{ text.beforeTag }}<span ng-transclude></span>{{ text.afterTag }}</span>',
            link: function ($scope, $element, $attrs) {
                if (!$attrs.text) {
                    return;
                }

                translate();

                $rootScope.$on('$translateChangeSuccess', translate);

                function translate() {
                    $scope.loading = true;

                    $translate($attrs.text).then(function(translation) {
                        var translatedStrings = translation.split(/%\[\w+\]/);

                        $scope.text = {
                            beforeTag: translatedStrings[0],
                            afterTag: translatedStrings[1]
                        }
                    }).finally(function() {
                        $scope.loading = false;
                    });
                }
            }
        }
    }]);
